module.exports = __webpack_public_path__ + "img/grey.29ca7ad4.png";